<template>
  <el-tabs v-model="activeName" class="interact-tab-item">
    <el-tab-pane label="聊天互动" name="chat">
      <div class="interact-list">
        <div class="chat">
          <div id="list" ref="listRef" class="chat-box">
            <ul ref="contentRef" class="chat-list">
              <li
                v-for="(item, index) in chat.list"
                :key="item.messageId"
                :ref="item.messageId"
                class="item"
              >
                <div v-if="isShowCreateTime(index)" class="chat-time">
                  <span class="chat-time__info"> {{ item.createTime }} </span>
                </div>
                <div class="chat-text">
                  <div class="user-head">
                    <img :src="item.profileUrl" alt="" />
                  </div>
                  <div v-if="item.type == '1'" class="right">
                    <div class="name">{{ item.username }}</div>
                    <!-- <div class="content" @click="replyItem = item"> -->
                    <!-- TODO 回复操作 -->
                    <div class="content">
                      <div class="text">{{ item.content[2] }}</div>
                    </div>
                    <div v-if="replyMsg(item.content[1])" class="content reply">
                      <div class="text">{{ replyMsg(item.content[1]) }}</div>
                    </div>
                  </div>
                  <div v-else class="right">
                    <div class="name">{{ item.username }}</div>
                    <!-- <div class="content" @click="replyItem = item"> -->
                    <!-- / TODO 回复操作 -->
                    <div class="content">
                      <div class="text">{{ item.content }}</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="chat-send">
            <div class="send-box">
              <div v-if="replyItem != ''" class="chat-reply">
                <span>{{ replyItem.username }}:</span>
                <span
                  :title="
                    replyItem.type == '1'
                      ? replyItem.content[2]
                      : replyItem.content
                  "
                  >{{
                    replyItem.type == '1'
                      ? replyItem.content[2]
                      : replyItem.content
                  }}</span
                >
                <i class="el-icon-close" @click="replyItem = ''"></i>
              </div>

              <div class="send-content">
                <el-input
                  v-model="chat.inputVal"
                  placeholder="我也要说点什么"
                  @change="change"
                  @keyup.enter.native="send"
                ></el-input>

                <div class="send-operation">
                  <!-- <div class="operation-item send-img">
                    <input
                      id="imageFile"
                      type="file"
                      accept="image/png,image/jpeg,image/jpg"
                      style="display: none"
                    />
                  </div> -->
                  <!-- <div class="operation-item send-emoji"></div> -->
                  <div class="send-btn unable" @click="send">发送</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import * as Api from '@/api'
import * as Utils from '@/utils/utils.js'
// import chatLoading from './components/loading.vue'
export default {
  name: 'chat',
  // components: { chatLoading },

  props: {
    liveId: {
      // 直播间ID
      type: String,
      require: true
    }
  },

  data() {
    return {
      activeName: 'chat',
      chat: {
        current: 1, // 留言页数
        size: 10,
        list: [], // 留言内容
        inputVal: '', // 聊天输入框输入内容
        total: 0,
        isMore: true // 聊天内容是否还有更多
      }, // 留言
      type: 'bottom', // 聊天窗滚动条位置
      replyItem: '' // 回复的消息内容
    }
  },

  computed: {
    // 回复消息
    replyMsg() {
      return (msgId) => {
        let data = ''
        const arr = this.chat.list.filter((item) => item.messageId === msgId)
        if (arr.length) {
          if (arr[0].type === '1') {
            data = `回复 ${arr[0].username}：${arr[0].content[2]}`
          } else {
            data = `回复 ${arr[0].username}：${arr[0].content}`
          }
        }
        return data
      }
    },
    // 显示时间
    isShowCreateTime() {
      return (index) => {
        if (index === 0) return true

        // 间隔5五分钟的信息不显示时间
        return (
          this.$moment(this.chat.list[index].createTime).format('x') -
            this.$moment(this.chat.list[index - 1].createTime).format('x') >
          5 * 60 * 1000
        )
      }
    }
  },

  watch: {
    liveId(newVal, oldVal) {
      console.log('chat--liveId--newVal,', newVal, '----oldVal----', oldVal)
      this.resetData()
      this.getChatList()
    },
    'chat.list'(newVal, oldVal) {
      console.log(newVal.length, oldVal.length)
      let messageId = ''
      if (newVal.length !== oldVal.length && oldVal.length) {
        messageId = oldVal[0].messageId
        this.type = 'top'
      } else {
        this.type = 'bottom'
      }
      this.$nextTick(() => {
        this.setScrollTop(messageId) // 控制请求列表接口后的滚动条位置
      })
    }
  },

  mounted() {
    this.init_load()

    document
      .getElementById('list')
      .addEventListener('scroll', this.scroll, false)
  },

  beforeDestroy() {
    document.getElementById('list') &&
      document
        .getElementById('list')
        .removeEventListener('scroll', this.scroll, false)
  },

  methods: {
    init_load() {
      this.resetData()
      this.getChatList()
    },
    async scroll(e) {
      const elem = document.getElementById('list')
      if (!elem) return

      const scrollTop = elem.scrollTop
      if (scrollTop > 1) return

      if (this.scrollMask) return
      this.scrollMask = true
      // this.$emit('nextPage', 'top')
      await this.getChatList()
      this.scrollMask = false
    },
    // 控制请求列表接口后的滚动条位置
    setScrollTop(messageId) {
      if (this.type === 'top' && this.$refs[messageId][0]) {
        this.$refs.listRef.scrollTop = this.$refs[messageId][0].offsetTop
      } else {
        this.$refs.listRef.scrollTop = this.$refs.contentRef.scrollHeight
      }
    },
    // 聊天框change事件
    change(e) {
      this.chat.inputVal = e
    },
    send() {
      if (!this.chat.inputVal) {
        this.$message('评论不能为空')
        return
      }
      this.$emit('send', {
        content: this.chat.inputVal,
        replyItem: this.replyItem
      })
      this.clearInput()
    },

    // 聊天室内容
    async getChatList() {
      if (this.chat.total <= this.chat.list.length && !this.chat.isMore) return
      const form = {
        current: this.chat.current,
        size: this.chat.size,
        isDelete: false,
        roomId: this.liveId,
        auditStatus: 1
      }
      try {
        const { data: res } = await Api.chat.getChatPage(form)
        res.items = res.items.reverse()
        res.items.forEach((item) => {
          if (item.type === '1') {
            item.content = item.content.split(':')
          }
        })
        this.chat.current === 1
          ? (this.chat.list = res.items)
          : (this.chat.list = [...res.items, ...this.chat.list])
        this.chat.total = res.total

        // 过滤掉在分页时，渲染了重复的留言
        this.chat.list = this.chat.list.filter((element, index, self) => {
          return (
            self.findIndex((x) => x.messageId === element.messageId) === index
          )
        })

        if (this.chat.list.length < res.total) {
          this.chat.current++
          this.chat.isMore = true
        } else {
          this.chat.isMore = false
        }
      } catch (error) {}
    },
    // 删除留言
    deleteMessage(messageId) {
      const index = this.chat.list.findIndex((item) => {
        return item.messageId === messageId
      })
      index >= 0 && this.chat.list.splice(index, 1)
    },
    // socket留言
    getMessage(data) {
      // 收到回复时处理
      if (parseInt(data.messageType) === 9) {
        data.content = data.content.split(':')
        data.type = 1
      }
      this.chat.list.push(data)
    },

    // 重置数据
    resetData() {
      this.chat.current = 1
      this.chat.isMore = true
      this.clearInput()
    },
    clearInput() {
      this.chat.inputVal = ''
    }
  }
}
</script>

<style lang="less" scoped>
body {
  font-family: 'PingFang SC', 'STHeitiSc-Light', 'Helvetica-Light', arial,
    sans-serif;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
/deep/ .el-tabs__content {
  height: 100%;
}
/deep/ .el-tab-pane {
  height: 100%;
}
/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs__nav-wrap {
  flex: 0 0 auto;
  position: relative;
  height: 44px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  background: #303030;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  // width: 100%;
  padding: 0 10px;
  border-radius: 8px 8px 0 0;
}
.interact-tab-item {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 8px;
  .blackOpacity();
  .backdropFilter();
}
/deep/ .el-tabs__item {
  color: #fff;
}
/deep/ .el-tabs__active-bar {
  height: 4px;
  border-radius: 4px;
}
/deep/ .el-tabs__nav-wrap {
  display: flex;
  justify-content: center;
  &::after {
    background-color: transparent;
  }
}
.interact-list {
  height: 100%;
}
.chat {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.chat-box {
  position: relative;
  flex: auto;
  width: 100%;
  overflow-y: scroll;
}
.chat-list {
  position: relative;
  .item {
    padding: 5px 10px;
  }
  .chat-time {
    margin-bottom: 10px;
    transform: scale(0.9);
    color: #fff;
    font-size: 12px;
    text-align: center;
  }
  .chat-time__info {
    display: inline-block;
    margin: auto;
    max-width: 90%;
    padding: 5px 8px;
    border-radius: 5px;
    background: @chat-time-bg-color;
    font-size: 12px;
    line-height: 1.75;
    text-align: center;
  }
  .chat-text {
    display: flex;
    .user-head {
      flex: 0 0 auto;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      flex: 1;
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      .name {
        text-align: left;
        color: @chat-name-color;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 6%);
        line-height: 20px;
        font-size: 12px;
        margin: 5px 0;
      }
      .content {
        position: relative;
        padding: 8px 10px;
        display: inline-block;
        width: fit-content;
        min-height: 16px;
        line-height: 16px;
        background: @chat-bg-color;
        background-size: 100% 100%;
        color: @chat-text-color;
        border: 1px solid @chat-bg-border-color;
        border-radius: 0 15px 15px 15px;
        font-size: 12px;
        white-space: pre-wrap;
        .text {
          position: relative;
          z-index: 2;
          min-width: 20px;
          text-align: left;
          word-break: break-all;
        }
      }
      .reply {
        margin-top: 10px;
        border-radius: 15px;
        opacity: 0.6;
      }
    }
  }
}
.chat-send {
  flex: 0 0 auto;
  padding: 10px 15px;
  height: 45px;
}

.send-box {
  position: relative;
  // padding: 10px;
  // height: 100%;
  background: #2c2c2c;
  border-radius: 8px;
}
.chat-reply {
  position: absolute;
  top: -40px;
  left: 0;
  padding: 5px 30px 5px 12px;
  width: calc(100% - 42px);
  height: 25px;
  line-height: 25px;
  background: #27282e;
  font-size: 16px;
  color: hsla(0, 0%, 100%, 0.5);
  border-radius: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  .el-icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 25px;
    height: 25px;
    cursor: pointer;
  }
}
.send-content {
  height: 100%;
  display: flex;
  align-items: center;
}
.send-operation {
  // position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  // width: 50%;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.send-img {
  background: url(../../../static/images/picture.png) no-repeat 50%;
  background-size: 100% 100%;
}
.send-emoji {
  background: url(../../../static/images/smile.png) no-repeat 50%;
  background-size: 100% 100%;
}
.send-btn {
  vertical-align: middle;
  display: inline-block;
  width: 80px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 18px;
  border-radius: 2px;
  cursor: pointer;
  color: #aeaeae;
  border-radius: 0 8px 8px 0;
  position: relative;
}
.unable {
  color: #aeaeae;
  &::after {
    content: '';
    position: absolute;
    top: 25%;
    left: 0;
    width: 1px;
    height: 50%;
    background: #565656;
  }
}
.operation-item {
  vertical-align: middle;
  margin-right: 12px;
  display: inline-block;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
/deep/ .el-input__inner {
  // width: 50%;
  background-color: transparent;
  border: 0;
  font-size: 15px;
  color: #fff;
  outline: none;
  resize: none;
  &::placeholder {
    color: #606266;
  }
}
</style>
